import type { ComponentType } from 'react';
import { memo } from 'react';

import { TimelineEventStyled } from '../styles/TimelineEventStyled'
import { type TimelineEvent as TimelineEventType } from '../types'
import { Header } from '@ui/elements/Header'
import { Icon } from '@ui/elements/Icon'
import { Spacer } from '@ui/elements/Spacer'
import { SubText } from '@ui/elements/Text'

export interface ITimelineEventProps extends TimelineEventType {}

export const TimelineEvent: ComponentType<ITimelineEventProps> =
  memo(({ title, metadata, icon, status, iconCircle }) => {
    const getMetadataText = () => {
      return metadata.map((meta, index) => {
        return (
          <SubText key={index} color='darkGrey' autoMargin={false}>
            {meta}
          </SubText>
        )
      })
    }

    return (
      <TimelineEventStyled
        iconCircle={iconCircle}
        status={status ? status : null}
        className='timeline-event'
      >
        <div className='gradient-line' />
        <div className='solid-line' />
        <div className='icon'>
          <Icon
            icon={icon}
            color={status ? status : 'disabled'}
            fontSize='3em'
          />
        </div>
        <Header color={status ? status : null} as='h5' fontSize={14}>
          {title}
        </Header>
        <Spacer space={0.5} />
        {getMetadataText()}
      </TimelineEventStyled>
    )
  })

TimelineEvent.defaultProps = {
  iconCircle: false,
  metadata: [],
}

TimelineEvent.displayName = 'TimelineEvent'
